import { Chip, FormControl, FormLabel, Grid2 } from '@mui/material'
import { TimePicker } from '@mui/x-date-pickers'
import moment from 'moment'
import React from 'react'
import { i18n } from '../../index'
import { RestaurantOpeningHours } from '../types'
import { WEEKDAYS } from '../util'

interface TimeSelectRowProps {
  day: keyof RestaurantOpeningHours
  openingHours: RestaurantOpeningHours
  selectTime: (weekDay: keyof RestaurantOpeningHours, field: 'opens' | 'closes', time: string | null) => void
  togglePopper: (day: keyof RestaurantOpeningHours, anchorEl: HTMLElement | null) => void
}

export default function TimeSelectRow({
  day,
  openingHours,
  selectTime,
  togglePopper,
}: TimeSelectRowProps): JSX.Element {
  return (
    <Grid2 container direction='row' spacing={2}>
      <Grid2 sx={{ minWidth: '150px' }}>
        <FormLabel>{i18n.t(`restaurantMenu.${WEEKDAYS[day].translationKey}`)}</FormLabel>
      </Grid2>
      <Grid2>
        <FormControl>
          <TimePicker
            value={moment(openingHours[day].opens, 'HH:mm')}
            onChange={(newValue) =>
              selectTime(day as keyof RestaurantOpeningHours, 'opens', newValue?.format('HH:mm') ?? null)
            }
          />
        </FormControl>
      </Grid2>
      <Grid2>
        <FormControl>
          <TimePicker
            value={moment(openingHours[day].closes, 'HH:mm')}
            onChange={(newValue) =>
              selectTime(day as keyof RestaurantOpeningHours, 'closes', newValue?.format('HH:mm') ?? null)
            }
          />
        </FormControl>
      </Grid2>
      {openingHours[day].opens === '00:00' && openingHours[day].closes === '00:00' && (
        <Grid2>
          <Chip size='small' color='warning' label={i18n.t('restaurantMenu.closed')} />
        </Grid2>
      )}
      {openingHours[day].opens === '00:00' && openingHours[day].closes === '23:59' && (
        <Grid2>
          <Chip size='small' color='primary' label={i18n.t('restaurantMenu.alwaysOpen')} />
        </Grid2>
      )}
    </Grid2>
  )
}
